import styled from '@emotion/styled';

export const RegistrationCustomersFormStyled = {
  Container: styled.div<any>``,
  Separator: styled.div<any>`
    margin-top: 15px;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    margin-top: 29px;
  `,
  ContainerCheckbox: styled.div<any>`
    display: flex;
    align-items: center;
  `,
};
